/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.5 24h17c1.1046 0 2-.8954 2-2V10.5366a2 2 0 0 0-1.4847-1.9325L16.5 7.4V2c0-1.1046-.8954-2-2-2h-11c-1.1046 0-2 .8954-2 2v20c0 1.1046.8954 2 2 2ZM8.25 1.5H3.5A.5.5 0 0 0 3 2v5.25h5.25V1.5ZM3 14.75v-6h5.25v6H3Zm0 1.5V22a.5.5 0 0 0 .5.5h4.75v-6.25H3Zm6.75 0v6.25H15v-6.25H9.75Zm5.25-1.5v-6H9.75v6H15Zm0-7.5H9.75V1.5h4.75a.5.5 0 0 1 .5.5v5.25Zm1.5 15.25V8.9524l4.1288 1.101a.5.5 0 0 1 .3712.4832V22a.5.5 0 0 1-.5.5h-4Z"
    clipRule="evenodd"
  />,
  'MenuOrganization'
);
